import UserDashboard from './component';
import MyTasks from './MyTasks';
import { routes as staffTasks } from './TeacherTasks';
import { routes as academicInfo } from './AcademicInfo';

export default {
  component: UserDashboard,
  indexRoute: {
    component: MyTasks,
  },
  tab: {
    label: 'My Tasks',
    order: 0,
  },
  childRoutes: [
    staffTasks,
    academicInfo,
  ],
};



// WEBPACK FOOTER //
// ./containers/UserDashboard/routes.js